import { render, staticRenderFns } from "./MaVach.vue?vue&type=template&id=cfe766ac&scoped=true&"
import script from "./MaVach.vue?vue&type=script&lang=js&"
export * from "./MaVach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe766ac",
  null
  
)

export default component.exports